import { useEffect } from "react";
import { useLang } from "@/context/LanguageContext";

const setMeta = (name, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setProp = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ page }) => {
  const { t, lang } = useLang();
  useEffect(() => {
    const seo = (t.seo && (t.seo[page] || t.seo.home)) || null;
    if (!seo) return;
    document.title = seo.title;
    document.documentElement.lang = lang;
    setMeta("description", seo.description);
    setMeta("keywords", seo.keywords);
    setProp("og:title", seo.title);
    setProp("og:description", seo.description);
    setProp("og:type", "website");
    setProp("og:site_name", "Sofas Contract");
  }, [t, lang, page]);
  return null;
};
